window.$catalog_budget_result = [];
window.$catalog_budget_didUpdateChange = true;
window.$catalog_budget_treeChangeStatus = false;
window.$catalog_budget_treeList = [];
window.$catalog_budget_page_number = 1;
window.$catalog_budget_newInsertId = [];
window.$catalog_budget_Glist = [];
window.$catalog_budget_content = [];
window.$catalog_budget_algemeenCode = [];
window.$catalog_budget_algemeenNaam = [];
window.$catalog_budget_algemeenJaar = [];
window.$catalog_budget_selectedRow = [];
window.$catalog_budget_gvv = 1;
window.$catalog_budget_filterMaatregelenIsActive = [];
window.$catalog_budget_filterPlannigIsActive = [];
window.$catalog_budget_filterContent = [];
window.$catalog_budget_filterClickStatus = false;
window.$catalog_budget_scroll_change = false;
window.$catalog_budget_columnList = [];
window.$catalog_budget_selectedIds = null;
window.$catalog_budget_token = null;
window.$catalog_budget_gebruiker_page_number = 1;
window.$catalog_budget_table_total_row_count = 0;
window.$catalog_budget_columnListPure = null;
window.$catalog_budget_refresh = function (){};
window.$catalog_budget_sliderImages = [];
window.$catalog_budget_context = null;
window.$catalog_budget_detail_context = null;

window.$catalog_budget_lastUsedTableFilter = {
  content: [],
  definitions: [],
};

window.$catalog_budget_actions = [];

window.$catalog_budget_last_tree_click = { budget: false, grootboek: false };

window.$catalog_budget_column_order_post_model = {
  client_identification: "",
  code: "",
  data: {
    table_sorting: [
      {
        name: "catalog>financial",
        column_list: [
          "checkbox",
          "active",
          "Type",
          "Naam",
          "paperclip",
          "Code",
          "Jaar",
          "Omschrijving",
        ],
      },
    ],
  },
};
